import { deliveryPackageConstants } from "@constants";

const initalState = {
  create: {
    processing: false
  },
  typeOptions: {
    loading: false,
    data: [],
    fail: null
  },
  deliverByOptions: {
    loading: false,
    data: [],
    fail: null
  },
  preserveOptions: {
    loading: false,
    data: [],
    fail: null
  }
};

export const deliveryPackage = (state = initalState, action) => {
  switch (action.type) {
    case deliveryPackageConstants.CREATE_DELIVERY_PACKAGE_REQUEST:
      return {
        ...state,
        create: {
          processing: true
        }
      };
    case deliveryPackageConstants.CREATE_DELIVERY_PACKAGE_DONE:
      return {
        ...state,
        create: {
          processing: false
        }
      };
    case deliveryPackageConstants.GET_TYPE_OPTIONS_REQUEST:
      return {
        ...state,
        typeOptions: {
          loading: true,
          data: []
        }
      };
    case deliveryPackageConstants.GET_TYPE_OPTIONS_SUCCESS:
      return {
        ...state,
        typeOptions: {
          loading: false,
          data: action.typeOptions
        }
      };
    case deliveryPackageConstants.GET_TYPE_OPTIONS_FAILURE:
      return {
        ...state,
        typeOptions: {
          loading: false,
          data: [],
          fail: action.error
        }
      };
    case deliveryPackageConstants.RESET_TYPE_OPTIONS_SUCCESS:
      return {
        ...state,
        typeOptions: initalState.typeOptions
      };
    case deliveryPackageConstants.GET_DELIVER_BY_OPTIONS_REQUEST:
      return {
        ...state,
        deliverByOptions: {
          loading: true,
          data: []
        }
      };
    case deliveryPackageConstants.GET_DELIVER_BY_OPTIONS_SUCCESS:
      return {
        ...state,
        deliverByOptions: {
          loading: false,
          data: action.deliverByOptions
        }
      };
    case deliveryPackageConstants.GET_DELIVER_BY_OPTIONS_FAILURE:
      return {
        ...state,
        deliverByOptions: {
          loading: false,
          data: [],
          fail: action.error
        }
      };
    case deliveryPackageConstants.RESET_DELIVER_BY_OPTIONS_SUCCESS:
      return {
        ...state,
        deliverByOptions: initalState.deliverByOptions
      };
    case deliveryPackageConstants.GET_PRESERVE_OPTIONS_REQUEST:
      return {
        ...state,
        preserveOptions: {
          loading: true,
          data: []
        }
      };
    case deliveryPackageConstants.GET_PRESERVE_OPTIONS_SUCCESS:
      return {
        ...state,
        preserveOptions: {
          loading: false,
          data: action.preserveOptions
        }
      };
    case deliveryPackageConstants.GET_PRESERVE_OPTIONS_FAILURE:
      return {
        ...state,
        preserveOptions: {
          loading: false,
          data: [],
          fail: action.error
        }
      };
    case deliveryPackageConstants.RESET_PRESERVE_OPTIONS_SUCCESS:
      return {
        ...state,
        preserveOptions: initalState.preserveOptions
      };
    default:
      return state;
  }
};
